import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import { Grid, Typography, Button } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles } from '@material-ui/core';


import ResetPassword from '../components/ResetPassword';
import UserRoles from '../components/UserRoles';


import userActions from '../actions/userActions';
import { LoginRequest } from '../types/LoginRequest';
import { UserData } from '../types/UserData';
import { userService } from '../services/userService';
import { MyPATLocalLoader } from '../../common';


const styles = (theme: Theme) => createStyles({
    loginLeft: {
        // background: 'url("/assets/img/login_background.svg")'
        backgroundImage: 'linear-gradient(180deg, #DDF0FF 27.43%, #E8FF98 120.61%)',
        height: '100vh',
        overflow: 'hidden',
        paddingTop: '50px',
        textAlign: 'center',
        '& h2':{
            fontWeight: 600,
        }
        
    },
    demoButton: {
        background: theme.palette.common.white,
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
        borderRadius: `${theme.spacing.unit * 7}px`,
        marginTop: `${theme.spacing.unit * 7}px`,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.193756)',
    },
    // customContainer:{
    //     display: 'grid',
    //     gridTemplateColumns: '45% 55%',
    // },
    loginLeftImg:{
        transform: 'scale(.9)',
        paddingBottom: 20,
        display: 'block',
        margin: '0 auto',
    },
});



  
//@ts-ignore
interface ResetPasswordContainerProps extends WithStyles<typeof styles> {
    classes: any,
    userData: UserData,
    login: Function,
    setSelectedRole: Function,
    match: any,
}

interface ResetPasswordContainerState {
    passwordReset:boolean;
}

class ResetPasswordContainer extends Component<ResetPasswordContainerProps, ResetPasswordContainerState>{

    constructor(props: ResetPasswordContainerProps, state: ResetPasswordContainerState) {
        super(props);

        this.state = {
            passwordReset:false
        }
        this.resetPassword = this.resetPassword.bind(this);
    }

    resetPassword(newPassword: any) {
        let resetHash = this.props.match.params.hash;
                  
        userService.resetPassword(newPassword, resetHash)
            .then(
                (res) => {
                    // window.location.href = `${window.location.origin}/login`
                   this.setState({
                    passwordReset:true 
                   })
                      },
                (error: any) => {
                }
            );
    }
   
        renderView(){
    return (
        <Redirect to="/login" />
    )
        }

    render() {

        const { classes } = this.props;
       
        return (
            <Grid container>
                <Grid item xs={6} className={classes.loginLeft}>
                    <Typography variant="h6" component="h2">Focus on what you do best and leave <br/> everything else to us</Typography>
                    <Typography variant="subtitle1" component="h4">Academic content authoring and management tool</Typography>
                    <Button className={classes.demoButton}>Watch Demo</Button>
                    <img className={classes.loginLeftImg} src="/assets/img/login-background-bg.png" alt="" />
                </Grid>
                <Grid item xs={6}>
                    <ResetPassword resetPassword={this.resetPassword} />
                </Grid>
                <Grid item xs={7}>
                    {this.state.passwordReset?
                    <>
                    {this.renderView()}
                    </>:
                    ''}
                </Grid>
            </Grid>
        );
    }

}


const mapStateToProps = (state: any) => {
    return {
        userData: state.loginData.userData
    };
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    login: userActions.login,
    setSelectedRole: userActions.setSelectedRole
}, dispatch)



// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ResetPasswordContainer));